export const actionTypes = {
  FETCH_PERSON_DOCUMENTS: 'MEMBER_PORTAL/FETCH_PERSON_DOCUMENTS',
  FETCH_PERSON_DOCUMENTS_LOADING: 'MEMBER_PORTAL/FETCH_PERSON_DOCUMENTS_LOADING',
  RESET_PERSON_DOCUMENTS: 'MEMBER_PORTAL/RESET_PERSON_DOCUMENTS',
};
